import { fromJS } from 'immutable';
import ACTIONS from 'store/constants';

const initialState: any = fromJS({
  loading: false,
  saving: false,
  invitation: '',
  notificationSetting: false,
  updateNotification: '',
  dateTimeSetting: '',
  updateDateTime: '',
  feedback: '',
  loggedTime: false,
  error: null,
});

export default function generalReducer(state = initialState, action: any) {
  switch (action.type) {
    case ACTIONS.INVITE_PEOPLE.PENDING: {
      return state.set('loading', true).set('error', null);
    }
    case ACTIONS.INVITE_PEOPLE.SUCCESS: {
      return state.set('loading', false).set('error', '').set('invitation', action.data.message);
    }
    case ACTIONS.INVITE_PEOPLE.ERROR: {
      return state.set('loading', false).set('error', action.error);
    }

    case ACTIONS.FEED_BACK.PENDING: {
      return state.set('loading', true).set('error', null);
    }
    case ACTIONS.FEED_BACK.SUCCESS: {
      return state.set('loading', false).set('error', '').set('feedback', action.data.message);
    }
    case ACTIONS.FEED_BACK.ERROR: {
      return state.set('loading', false).set('error', action.error);
    }

    case ACTIONS.NOTIFICATION_SETTING.PENDING: {
      return state.set('loading', true).set('error', null);
    }
    case ACTIONS.NOTIFICATION_SETTING.SUCCESS: {
      return state.set('loading', false).set('error', '').set('notificationSetting', action.data.notification);
    }
    case ACTIONS.NOTIFICATION_SETTING.ERROR: {
      return state.set('loading', false).set('error', action.error);
    }

    case ACTIONS.UPDATE_NOTIFICATION_SETTING.PENDING: {
      return state.set('saving', true).set('error', null).set('updateNotification', '');
    }
    case ACTIONS.UPDATE_NOTIFICATION_SETTING.SUCCESS: {
      return state.set('saving', false).set('error', '').set('updateNotification', action.data.message);
    }
    case ACTIONS.UPDATE_NOTIFICATION_SETTING.ERROR: {
      return state.set('saving', false).set('error', action.error);
    }

    case ACTIONS.DATE_TIME_SETTING.PENDING: {
      return state.set('loading', true).set('error', null);
    }
    case ACTIONS.DATE_TIME_SETTING.SUCCESS: {
      return state.set('loading', false).set('error', '').set('dateTimeSetting', action.data);
    }
    case ACTIONS.DATE_TIME_SETTING.ERROR: {
      return state.set('loading', false).set('error', action.error);
    }

    case ACTIONS.UPDATE_DATE_TIME_SETTING.PENDING: {
      return state.set('saving', true).set('error', null).set('updateDateTime', '');
    }
    case ACTIONS.UPDATE_DATE_TIME_SETTING.SUCCESS: {
      let next = state.set('saving', false).set('error', null).set('updateDateTime', action.data.message);
      if (action.setting) {
        next = next.set('dateTimeSetting', action.setting);
      }
      return next;
    }
    case ACTIONS.UPDATE_DATE_TIME_SETTING.ERROR: {
      return state.set('saving', false).set('error', action.error).set('updateDateTime', '');
    }

    case ACTIONS.LOGGED_TIME.PENDING: {
      return state.set('loading', true).set('error', null).set('loggedTime', false);
    }
    case ACTIONS.LOGGED_TIME.SUCCESS: {
      return state.set('loading', false).set('error', '').set('loggedTime', true);
    }
    case ACTIONS.LOGGED_TIME.ERROR: {
      return state.set('loading', false).set('error', action.error).set('loggedTime', false);
    }

    case ACTIONS.LOGGED_TIME_RESET: {
      return state.set('loggedTime', false);
    }

    default: {
      return state;
    }
  }
}
